import {
  DaySequenceStatus,
  PayRunCycleLogStatus,
} from '@core/generated/gql-types';
import { formatEnumLabel } from '@/modules/payroll/utils/payrollFormat.utils';

const STATUS_CLASSES: Record<string, string> = {
  [DaySequenceStatus.ReadyForPay]: 'bg-green-100 text-green-800',
  [DaySequenceStatus.RequiresApproval]: 'bg-amber-100 text-amber-800',
  [DaySequenceStatus.EscalatedToTenant]: 'bg-orange-100 text-orange-800',
  [DaySequenceStatus.PayProcessed]: 'bg-blue-100 text-blue-800',
  [DaySequenceStatus.ProposedChange]: 'bg-purple-100 text-purple-800',
  [DaySequenceStatus.ErrorEncountered]: 'bg-red-100 text-red-800',
  [PayRunCycleLogStatus.Completed]: 'bg-green-100 text-green-800',
  [PayRunCycleLogStatus.CompletedWithErrors]: 'bg-red-100 text-red-800',
  [PayRunCycleLogStatus.Failed]: 'bg-red-100 text-red-800',
  [PayRunCycleLogStatus.Processing]: 'bg-blue-100 text-blue-800',
};

type PayrollStatusPillProps = {
  status?: string | null;
  label?: string;
};

const PayrollStatusPill = ({ status, label }: PayrollStatusPillProps) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${
      (status && STATUS_CLASSES[status]) ?? 'bg-gray-100 text-gray-800'
    }`}
  >
    {label ?? formatEnumLabel(status)}
  </span>
);

export default PayrollStatusPill;
